import { render } from "./PromoCodes.vue?vue&type=template&id=9b5f5fc4"
import script from "./PromoCodes.vue?vue&type=script&lang=js"
export * from "./PromoCodes.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__